export const searchConfig = SEARCH_CONFIG?.recommend || {
  siteId: 'materialbank_product',
  siteUrl: 'https://search.materialbank.com/v2/recommend',
  context: 'catalog',
};
